import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { supabase } from '@/integrations/supabase/client';
import { Users, Search, Database, Package, Megaphone, Store } from 'lucide-react';

export default function AdminDashboard() {
  const [stats, setStats] = useState({ users: 0, searches: 0, cache: 0, catalog: 0, stores: 0, announcements: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const [u, s, c, cat, st, an] = await Promise.all([
        supabase.from('profiles').select('*', { count: 'exact', head: true }),
        supabase.from('search_history').select('*', { count: 'exact', head: true }),
        supabase.from('price_cache').select('*', { count: 'exact', head: true }),
        supabase.from('grocery_catalog').select('*', { count: 'exact', head: true }),
        supabase.from('store_settings').select('*', { count: 'exact', head: true }),
        supabase.from('announcements').select('*', { count: 'exact', head: true }),
      ]);
      setStats({
        users: u.count ?? 0,
        searches: s.count ?? 0,
        cache: c.count ?? 0,
        catalog: cat.count ?? 0,
        stores: st.count ?? 0,
        announcements: an.count ?? 0,
      });
      setLoading(false);
    })();
  }, []);

  const tiles = [
    { label: 'Total Users', value: stats.users, icon: Users, color: 'text-primary' },
    { label: 'Total Searches', value: stats.searches, icon: Search, color: 'text-info' },
    { label: 'Cache Entries', value: stats.cache, icon: Database, color: 'text-warning' },
    { label: 'Catalog Items', value: stats.catalog, icon: Package, color: 'text-success' },
    { label: 'Stores', value: stats.stores, icon: Store, color: 'text-destructive' },
    { label: 'Announcements', value: stats.announcements, icon: Megaphone, color: 'text-foreground' },
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Overview</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {tiles.map((t) => (
          <Card key={t.label}>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">{t.label}</CardTitle>
              <t.icon className={`h-5 w-5 ${t.color}`} />
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold">{loading ? '—' : t.value}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}